function isTouchScreen() {
  return typeof window !== "undefined" && "matchMedia" in window && window.matchMedia("(pointer: coarse)").matches;
}

export { isTouchScreen };
//# sourceMappingURL=isTouchScreen.js.map
